
import { useAuthStore } from '@common/store/auth'

const ID_TOKEN_KEY = 'id_token'
const REFRESH_TOKEN = 'refresh_token'

export const getToken = () => {
    return window.localStorage.getItem(ID_TOKEN_KEY)
}

export const getRefreshToken = () => {
    return window.localStorage.getItem(REFRESH_TOKEN)
}

export const saveToken = (token : string, refreshToken?: string) => {
    window.localStorage.setItem(ID_TOKEN_KEY, token);
    if (refreshToken) {
        window.localStorage.setItem(REFRESH_TOKEN, refreshToken);
    }
}

export const destroyToken = () => {
    window.localStorage.removeItem(ID_TOKEN_KEY)
    window.localStorage.removeItem(REFRESH_TOKEN);
}

export default { getToken, saveToken, destroyToken, getRefreshToken };
